// 26.1.10 Reflect.isExtensible(target)
var $export       = require('./$.export')
  , anObject      = require('./$.an-object')
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/es6.reflect.is-extensible.js
 ** module id = 545
 ** module chunks = 0 1 4 5 6 7 8
 **/